import FilterInTable from "../../../../Manage/FilterInTable"
import styles from "./styles.module.scss"
import DataTable from "react-data-table-component"
import { FaStar } from "react-icons/fa"
import ProductImage from "../../../../../assets/images/product-image-headphones.png"
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai"
import { useEffect, useState } from "react"
import PaginationComponent from "../../../../Manage/PaginationComponent"

const ProductReviews = () => {
  const [itemsPerPage, setItemsPerPage] = useState(3)
  const [currentPage, setCurrentPage] = useState(1)
  const [currentItems, setCurrentItems] = useState([])

  const data = [
    {
      reviewId: "000",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "002",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
    {
      reviewId: "001",
      product: { productName: "Product name", productId: "#123456789", productImage: ProductImage, date: "30 March 2024", likes: 11, dislikes: 0 },
      customerName: "William John",
      review: `Impressive product! This product exceeded my expectations. It's well-made and functions perfectly.`,
      attachments: "",
      rating: 5,
      status: "Not replied",
    },
  ]

  const columns = [
    {
      name: "Review ID",
      selector: (row) => row.reviewId,
      sortable: true,
      grow: 1,
    },
    {
      name: "Product Name",
      cell: (row) => (
        <div>
          <div className="d-flex gap-2">
            <div className={styles["product-image-container"]}>
              <img src={row.product.productImage} alt="" srcset="" width={38} height={35} />
            </div>
            <div>
              <div>{row.product.productName}</div>
              <div>{row.product.productId}</div>
            </div>
          </div>
          <div className="d-flex gap-3 mt-2">
            <div>{row.product.date}</div>
            <div className="d-flex gap-2">
              <div className="d-flex">
                <div>{row.product.likes}</div>
                <div className="d-flex align-items-center">
                  <AiOutlineLike />
                </div>
              </div>
              <div className="d-flex">
                <div>{row.product.dislikes}</div>
                <div className="d-flex align-items-center">
                  <AiOutlineDislike />
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: "Customer Name",
      selector: (row) => row.customerName,
      sortable: true,
      grow: 1,
    },
    {
      name: "Review",
      selector: (row) => row.review,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: "Attachments",
      selector: (row) => row.attachment,
      grow: 1,
    },
    {
      name: "Rating",
      cell: (row) => (
        <div className={styles["star"]}>
          {Array.from({ length: row.rating }, (v, i) => (
            <FaStar key={i} />
          ))}
        </div>
      ),
      sortable: true,
      grow: 1,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      grow: 1,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <div>
            <button onClick={() => handleReply(row.reviewId)} className={styles["button"]}>
              Reply
            </button>
          </div>
          <div>
            <button onClick={() => handleReport(row.reviewId)} className={styles["button"]}>
              Report
            </button>
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      grow: 1,
    },
  ]

  const handleReply = (reviewId) => {
    // Handle reply action
    console.log(`Reply to review ID: ${reviewId}`)
  }

  const handleReport = (reviewId) => {
    // Handle report action
    console.log(`Report review ID: ${reviewId}`)
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    const startIndex = (page - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    setCurrentItems(data.slice(startIndex, endIndex))
  }

  const handleRowsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage)
    setCurrentPage(1)
    handlePageChange(1)
  }

  useEffect(() => {
    handlePageChange(currentPage)
  }, [currentPage, itemsPerPage])

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#FBBD34",
        color: "#ffffff",
        fontSize: "1rem",
        fontWeight: 600,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <div className={`p-3 ${styles["outer-wrapper"]}`}>
      <FilterInTable componentName="Customer Engage Product Reviews" />
      <div className="my-3">
        <DataTable data={currentItems} columns={columns} customStyles={customStyles} />
      </div>
      <PaginationComponent
        totalItems={data.length}
        siblingCount={2}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  )
}

export default ProductReviews
